import React from "react";
import { ListWrapper} from "../ui/Catalog";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {panel} from "../repository/panel";
import DetailsProduct from "../ui/Catalog/DetailsProducts";


const PanelController = (props) => {
    return <div>
        {!props.match.params.id
            ? <ListWrapper {...props} url={'panel'}/>
            : <DetailsProduct products={panel} id={props.match.params.id}/>}
    </div>
};

const mapState = (state) => {
    return {
        data: state.catalogPage.panel
    }
};

export default withRouter(connect(mapState, null)(PanelController));
